import { lazyLoad } from '@utils/loadable';

export const PiecripAssetsPage = lazyLoad(
  () => import('./index'),
  (module) => module.default
);
